import {
  EntityDropdownInputBare,
  type EntityDropdownInputBareProps,
} from "#batteries-included-components/Dropdowns/EntityDropdownInputBare";
import { FormSchemaAdapter } from "@validereinc/domain";
import React from "react";

/**
 * Uncontrolled Form Schema dropdown using DropdownInputBare for use in FilterBuilder.
 * Value is controlled by parent (e.g. filter state); does not register with react-hook-form.
 */
export const FormSchemaDropdownInputBare = (
  props: Omit<EntityDropdownInputBareProps<unknown>, "fetchEntityList">
) => {
  return (
    <EntityDropdownInputBare
      fetchEntityList={FormSchemaAdapter.getList}
      label={props.label ?? "Form Template"}
      sort={{
        sortBy: "name",
        sortDirection: "asc",
      }}
      fetchFilters={{ status: "active" }}
      {...props}
    />
  );
};
